// extracted by mini-css-extract-plugin
export default {"details":"style--details--af4d56","withTodayBadge":"style--withTodayBadge--807387"};